var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyPets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#00a0df;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.33,
    y: -0.54,
    width: 600,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "dashboard"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.67,
    y: 0.8,
    width: 600,
    height: 600,
    rx: 86.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M499.12,282,322.8,96.65a29.72,29.72,0,0,0-43.07,0l-57.35,60.28V143.31a20,20,0,0,0-20-20H169.19a20,20,0,0,0-20,20v90.56L103.4,282c-18,18.93-4.59,50.21,21.54,50.21h22.65V495.52a14.39,14.39,0,0,0,14.54,14.25H438.62a14.4,14.4,0,0,0,14.54-14.25V332.21h24.43C503.71,332.21,517.13,300.93,499.12,282Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M340.33,394.23V511.42A20,20,0,0,1,340,515H262.52a19.94,19.94,0,0,1-.33-3.58V394.23c0-8.43,5.21-15.26,11.62-15.26h54.91C335.13,379,340.33,385.8,340.33,394.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M496.94,343.42l-181.72-191a21,21,0,0,0-14.06-6.47h-.06c-.43,0-.87,0-1.31,0s-.87,0-1.3,0h-.06a21,21,0,0,0-14.06,6.47l-181.72,191a21.12,21.12,0,0,0,.74,29.77h0a21.13,21.13,0,0,0,29.78-.74L299.79,197.29,466.42,372.45a21.06,21.06,0,0,0,30.52-29Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPets);
export default __webpack_public_path__ + "static/media/my_pets.ef4706566e29c0b250ce409a836ed6a4.svg";
export { ForwardRef as ReactComponent };